import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=dd82cf26&scoped=true&"
import script from "./Club.vue?vue&type=script&lang=js&"
export * from "./Club.vue?vue&type=script&lang=js&"
import style0 from "./Club.vue?vue&type=style&index=0&id=dd82cf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd82cf26",
  null
  
)

export default component.exports